import * as React from 'react';
import { observer } from 'mobx-react';
import { ExperienceResource } from '../../../../../../../../../../../../../Types';
import ClockIcon from '../../../../../../../../../../../../../../Cutesies/ClockIcon';
import Hours from '../../../../../../../../../../../../Hours';
import CheckmarkCircleIcon from '../../../../../../../../../../../../../../Cutesies/CheckmarkCircleIcon';
import { T } from '../../../../../../../../../../../../../../../Translations';

export interface Props {
  resource: ExperienceResource;
}

const ExperienceHours: React.FC<Props> = ({ resource }) => (
  <div className="flex mb-5">
    {resource.payload.totalHours
      .map((totalHours) => {
        return (
          <Hours>
            <span className="mr-2">
              <ClockIcon />
            </span>
            <span>
              <T kind="{{count}} Hour" count={totalHours} />
            </span>
          </Hours>
        );
      })
      .getOrElse(() => (
        <></>
      ))}
    {resource.payload.hoursPerWeek
      .map((hoursPerWeek) => {
        return (
          <Hours>
            <span className="mr-2 w-[15px] h-[15px]">
              <CheckmarkCircleIcon />
            </span>
            <span>
              <T kind="{{count}} Hour_per_week" count={hoursPerWeek} />
            </span>
          </Hours>
        );
      })
      .getOrElse(() => (
        <></>
      ))}
  </div>
);

export default observer(ExperienceHours);
